import React, { Component } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import projectStore from "../../stores/projectStore";
import { observer } from "mobx-react";
import {
  AddNewTalentColoredIcon,
  CloudIconColored,
  SearchColoredIcon,
  ShareIcon,
} from "../../assets/icons";
import Button from "../../components/Button";
import {
  LuCopy,
  LuExternalLink,
  LuFilePlus,
  LuFolder,
  LuFolderOpen,
  LuMail,
  LuPauseCircle,
  LuPlayCircle,
  LuPlaySquare,
  LuTrash,
} from "react-icons/lu";
import voiceStore from "../../stores/voiceStore";
import SearchNav from "../../components/SearchNav";
import {
  FaEdit,
  FaTrash,
  FaMinus,
  FaUndo,
  FaWhatsapp,
  FaTimes,
} from "react-icons/fa";
import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { TouchBackend } from "react-dnd-touch-backend";
import { toast } from "react-toastify";
import { PiWarningCircleFill } from "react-icons/pi";
import { Bars } from "react-loader-spinner";
import { BsPersonFillCheck } from "react-icons/bs";
import { Tooltip } from "react-tooltip";

function withRouter(Component) {
  return function WrapperComponent(props) {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    return (
      <Component
        {...props}
        location={location}
        params={params}
        navigate={navigate}
      />
    );
  };
}

const ProjectDetail = observer(
  class ProjectDetail extends Component {
    constructor(props) {
      super(props);
      this.state = {
        openFolders: {},
        folderTree: this.convertToFolderTree(voiceStore.searchResults),
        rightPanelFolders: [],
        newFolderName: "NewFolder",
        showDeleteModal: false,
        showShareProjectModal: false,
        shareProjectLink: null,
        projectName: null,
        loading: false,
        isMobile: window.innerWidth <= 767,
      };
    }

    toggleShareProjectModal = (bool) => {
      if (bool === false) {
        this.setState({ showShareProjectModal: false });
        return;
      }

      let url =
        process.env.REACT_APP_REDIRECT_URL +
        "/shared-projects/view/" +
        this.props.params.projectId;

      this.setState({
        showShareProjectModal: !this.state.showShareProjectModal,
        shareProjectLink: url,
      });
    };

    toggleDeleteModal = () => {
      this.setState({ showDeleteModal: !this.state.showDeleteModal });
    };

    handleDelete = (data) => {
      projectStore.deleteProject(data).then(() => {
        this.toggleDeleteModal();
        const { navigate } = this.props;
        navigate(`/projects`);
      });
    };

    toggleFolder = (id) => {
      this.setState((prevState) => {
        const newOpenFolders = { ...prevState.openFolders };
        newOpenFolders[id] = !newOpenFolders[id];
        return { openFolders: newOpenFolders };
      });
    };

    renderTree = (nodes) => {
      return (
        <ul className="flex flex-1 flex-col  list-disc ml-4 ">
          {nodes.map((node) => (
            <li key={node.id} className="flex flex-col items-start mb-2">
              {node.type === "folder" ? (
                <>
                  <div
                    className="cursor-pointer  flex items-center "
                    onClick={() => this.toggleFolder(node.id)}
                  >
                    {this.state.openFolders[node.id] ? (
                      <LuFolderOpen className="mr-2" size={20} />
                    ) : (
                      <LuFolder className="mr-2" size={20} />
                    )}
                    <span>{node.name}</span>
                  </div>
                  {this.state.openFolders[node.id] && (
                    <ul className="flex flex-1 flex-col w-[90%] ml-4">
                      {node.children.map((child) => (
                        <li className="flex w-full" key={child.sample_id}>
                          <this.FileItem file={child} />
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              ) : (
                <this.FileItem file={node} />
              )}
            </li>
          ))}
        </ul>
      );
    };

    convertToFolderTree = (data) => {
      return data.map((talent) => {
        return {
          id: talent.talent_id,
          name: talent.talent_name,
          type: "folder",
          children: talent.voice_data.map((voice) => ({
            talent_id: talent.talent_id,
            talent_name: talent.talent_name,
            sample_id: voice.sample_id,
            name: voice.fileName,
            type: "file",
            filePath: voice.voice_path,
            fileType: voice.fileType,
            voiceModulationPath: voice.voice_modulation_path,
            tags: voice.tags,
          })),
        };
      });
    };

    convertToFolderTree2 = (data) => {
      return data.map((folder) => {
        return {
          id: folder.folderId,
          name: folder.folderName,
          type: "folder",
          isDeleted: false,
          children:
            folder.voiceModel &&
            folder.voiceModel.map((sample) => ({
              talent_id: sample.talentId,
              sample_id: sample.sampleId,
              name: sample.voiceName,
              type: "file",
              filePath:
                process.env.REACT_APP_BASE_URL + "/" + sample.samplePath,
              isDeleted: false,
              isClientSelected: sample.isClientSelected,
            })),
        };
      });
    };

    handleCreateFolder = () => {
      const newFolder = {
        id: Date.now().toString(),
        name: this.state.newFolderName,
        type: "folder",
        children: [],
        isDeleted: false,
        isNew: true,
      };
      this.setState((prevState) => ({
        rightPanelFolders: [...prevState.rightPanelFolders, newFolder],
        newFolderName: "NewFolder" + (prevState.rightPanelFolders.length + 1),
      }));
    };

    handleRenameFolder = (id, newName) => {
      const isDuplicateName = this.state.rightPanelFolders.some(
        (folder) => folder.name === newName && folder.id !== id
      );
      if (isDuplicateName) {
        toast.warn("A folder with the same name already exists.");
        return false;
      }

      const updatedFolders = this.state.rightPanelFolders.map((folder) => {
        if (folder.id === id) {
          return { ...folder, name: newName };
        }
        return folder;
      });

      this.setState({ rightPanelFolders: updatedFolders });
    };

    handleDeleteFolder = (id) => {
      const updatedFolders = this.state.rightPanelFolders
        .map((folder) => {
          if (folder.id === id) {
            if (folder.isNew) {
              return null;
            }

            const updatedChildren = folder.children.map((child) => {
              return { ...child, isDeleted: true };
            });

            return { ...folder, isDeleted: true, children: updatedChildren };
          }
          return folder;
        })
        .filter((folder) => folder !== null);

      this.setState({ rightPanelFolders: updatedFolders });
    };

    handleDiscardDeleteFolder = (id) => {
      const updatedFolders = this.state.rightPanelFolders
        .map((folder) => {
          if (folder.id === id) {
            if (folder.isNew) {
              return null;
            }

            const updatedChildren = folder.children.map((child) => {
              return { ...child, isDeleted: false };
            });

            return { ...folder, isDeleted: false, children: updatedChildren };
          }
          return folder;
        })
        .filter((folder) => folder !== null);

      this.setState({ rightPanelFolders: updatedFolders });
    };

    handleDropFileToFolder = (file, folderId) => {
      this.setState((prevState) => {
        const updatedFolders = prevState.rightPanelFolders.map((folder) => {
          if (folder.id === folderId) {
            const fileExists = folder.children.some(
              (child) => child.sample_id === file.sample_id
            );

            if (!fileExists) {
              return { ...folder, children: [...folder.children, file] };
            } else {
              toast.warning("File already exists in the folder");
            }
          }
          return folder;
        });
        return { rightPanelFolders: updatedFolders };
      });
    };

    handleRemoveChild = (folderId, sampleId) => {
      this.setState((prevState) => {
        const updatedFolders = prevState.rightPanelFolders.map((folder) => {
          if (folder.id === folderId) {
            const updatedChildren = folder.children
              .filter((child) => {
                if (
                  child.isDeleted === undefined &&
                  child.sample_id === sampleId
                ) {
                  return false;
                }
                return true;
              })
              .map((child) => {
                if (child.isDeleted === false && child.sample_id === sampleId) {
                  return { ...child, isDeleted: true };
                }
                return child;
              });

            return { ...folder, children: updatedChildren };
          }
          return folder;
        });

        return { rightPanelFolders: updatedFolders };
      });
    };

    handleDiscardRemoveChild = (folderId, sampleId) => {
      this.setState((prevState) => {
        const updatedFolders = prevState.rightPanelFolders.map((folder) => {
          if (folder.id === folderId) {
            const updatedChildren = folder.children.map((child) => {
              if (child.isDeleted === true && child.sample_id === sampleId) {
                return { ...child, isDeleted: false };
              }
              return child;
            });

            return { ...folder, isDeleted: false, children: updatedChildren };
          }
          return folder;
        });

        return { rightPanelFolders: updatedFolders };
      });
    };

    renderRightPanelFolders = () => {
      return this.state.rightPanelFolders.map((folder) => (
        <this.FolderItem
          key={folder.id}
          folder={folder}
          onRename={this.handleRenameFolder}
          onDelete={this.handleDeleteFolder}
          onDrop={this.handleDropFileToFolder}
          onRemoveChild={this.handleRemoveChild}
        />
      ));
    };

    FileItem = ({ file }) => {
      const [isPlaying] = React.useState(false);
      const [{ isDragging }, drag] = useDrag(() => ({
        type: "FILE",
        item: file,
        collect: (monitor) => ({
          isDragging: monitor.isDragging(),
        }),
        options: {
          dropEffect: "copy",
        },
      }));

      let ismp4 = file.fileType === "mp4" || file.name.includes("mp4");

      const handlePlayPause = () => {
        if (ismp4) {
          voiceStore.setCurrentVoice(null);
          voiceStore.setVideoModal({
            video: file.filePath,
            fileName: file.name,
          });
        } else {
          voiceStore.setCurrentVoice(null);
          setTimeout(() => {
            voiceStore.setCurrentVoice({
              talent_id: file.talent_id,
              talent_name: file.talent_name ? file.talent_name : file.name,
              voice_path: file.filePath,
              voice_modulation_path: file.voiceModulationPath,
              sample_id: file.sample_id,
              IsFavorite: file.isFavorite,
            });
            voiceStore.togglePlayPause(true);
          }, 500);
        }
      };

      return (
        <>
          <button
            ref={drag}
            className={`flex flex-1 w-full flex-col lg:flex-row lg:justify-between lg:items-center  mt-2 mb-2 ${
              isDragging ? "opacity-50" : ""
            }`}
            onClick={handlePlayPause}
          >
            <div
              className={`flex flex-row justify-center items-center ${
                file.isDeleted && "line-through text-red-500"
              }`}
            >
              {isPlaying ? (
                <LuPauseCircle className="mr-2" size={20} />
              ) : ismp4 ? (
                <LuPlaySquare className="mr-2" size={20} />
              ) : (
                <LuPlayCircle className="mr-2" size={20} />
              )}
              <span className={`cursor-move`}>{file.name}</span>
              {file.isClientSelected === "True" && (
                <BsPersonFillCheck
                  className={`text-[#F89A1F] text-xl ml-2 tooltip`}
                />
              )}
              <Tooltip
                anchorSelect=".tooltip"
                content="This sound was selected by the client."
                style={{ fontSize: 12 }}
              />
            </div>

            <span className="flex flex-1 items-center flex-wrap justify-center ml-7 lg:ml-0">
              {file.tags &&
                Object.keys(file.tags).map((key, idx) => (
                  <div key={key} className="flex flex-wrap">
                    {file.tags[key].map((item, index) => (
                      <span className="text-xs text-gray-500" key={index}>
                        {item && idx !== 0 && " / "} {item}
                      </span>
                    ))}
                  </div>
                ))}
            </span>
          </button>
        </>
      );
    };

    FolderItem = ({ folder, onRename, onDelete, onDrop, onRemoveChild }) => {
      const [{ isOver }, drop] = useDrop(() => ({
        accept: "FILE",
        drop: (item) => onDrop(item, folder.id),
        collect: (monitor) => ({
          isOver: monitor.isOver(),
        }),
      }));

      const [isEditing, setIsEditing] = React.useState(false);
      const [newFolderName, setNewFolderName] = React.useState(folder.name);
      const [originalFolderName, setOriginalFolderName] = React.useState(
        folder.name
      );

      const handleEditClick = () => {
        setIsEditing(true);
        setOriginalFolderName(newFolderName);
      };

      const handleInputChange = (e) => {
        setNewFolderName(e.target.value);
      };

      const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          let onr = onRename(folder.id, newFolderName);
          if (onr === false) {
            setNewFolderName(originalFolderName);
          }
          setIsEditing(false);
        }
      };

      const handleBlur = () => {
        let onr = onRename(folder.id, newFolderName);
        if (onr === false) {
          setNewFolderName(originalFolderName);
        }
        setIsEditing(false);
      };

      return (
        <div
          ref={drop}
          className={`flex flex-col p-2 ${
            isOver ? "bg-gray-100" : "bg-white"
          }  rounded-md group`}
        >
          <div className="flex items-center w-full">
            <LuFolderOpen
              size={20}
              className={`mr-2 ${
                folder.isDeleted && "line-through text-red-500"
              }`}
            />
            {isEditing ? (
              <input
                type="text"
                value={newFolderName}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
                autoFocus
                className="font-semibold border p-1 rounded"
              />
            ) : (
              <span
                className={`cursor-pointer ${
                  folder.isDeleted && "line-through text-red-500"
                }`}
              >
                {folder.name}
              </span>
            )}

            <div className="flex space-x-2 ml-4">
              {!folder.isDeleted ? (
                <>
                  <FaEdit
                    onClick={handleEditClick}
                    className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  />
                  <FaTrash
                    onClick={() => onDelete(folder.id)}
                    className="lg:hidden group-hover:flex text-[#F89A1F] cursor-pointer transition-all"
                  />
                </>
              ) : (
                <FaUndo
                  onClick={() => this.handleDiscardDeleteFolder(folder.id)}
                  className="flex text-black cursor-pointer transition-all"
                />
              )}
            </div>
          </div>

          {/* Child Files */}
          {folder.children && folder.children.length > 0 && (
            <ul className="flex flex-col flex-1 w-full ml-4">
              {folder.children.map((child) => (
                <div
                  key={child.sample_id}
                  className="flex flex-1 w-full flex-row items-center gap-x-2"
                >
                  {child.isDeleted ? (
                    <FaUndo
                      onClick={() =>
                        this.handleDiscardRemoveChild(
                          folder.id,
                          child.sample_id
                        )
                      }
                      className="mr-2 cursor-pointer"
                    />
                  ) : (
                    <FaMinus
                      onClick={() => onRemoveChild(folder.id, child.sample_id)}
                      className="mr-2 cursor-pointer"
                    />
                  )}

                  <this.FileItem file={child} folder={folder} />
                </div>
              ))}
            </ul>
          )}
        </div>
      );
    };

    loadData = async (data) => {
      let folders = [];
      if (data) {
        this.setState({ rightPanelFolders: [] });
        folders = data;
      } else {
        folders = await projectStore.getProjectDetails(
          this.props.params.projectId
        );
      }

      setTimeout(() => {
        let fol = this.convertToFolderTree2(folders);

        fol.forEach((newFolder) => {
          this.setState((prevState) => ({
            rightPanelFolders: [...prevState.rightPanelFolders, newFolder],
          }));
        });
      }, 200);
    };

    copyToClipboard = (url) => {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          toast.info("Link copied to clipboard.");
        })
        .catch((error) => {
          toast.error("Failed to copy link to clipboard.");
        });
    };

    async componentDidMount() {
      this.loadData();
      const { location } = this.props;

      if (location.state) {
        const { projectName } = location.state;
        this.setState({ projectName: projectName });
      } else if (projectStore.projects.length > 0) {
        let project_name = projectStore.projects.find(
          (project) => project.project_id === this.props.params.projectId
        )?.project_name;
        this.setState({ projectName: project_name });
      } else {
        this.setState({ projectName: this.props.params.projectId });
      }

      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        this.toggleShareProjectModal(false);
      }
    };

    render() {
      const { year, clientName, projectId } = this.props.params;
      const { loading, isMobile } = this.state;

      return (
        <div className="flex flex-1 flex-col p-0 lg:p-8">
          <div className="flex flex-col lg:flex-row lg:mb-2 justify-between">
            <div className="p-2 lg:p-0">
              <Link to={`/projects`}>Projects</Link>
              <span>{" > "}</span>
              <Link to={`/projects/${year}`}>{year}</Link>
              <span>{" > "}</span>
              <Link to={`/projects/${year}/${clientName}`}>{clientName}</Link>
              <span>{" > "}</span>
              <span className="font-bold">{this.state.projectName}</span>
            </div>

            <div className="flex flex-row gap-x-3 justify-end lg:justify-start mr-5 lg:mr-0">
              <Button
                onClick={this.handleCreateFolder}
                className="hidden md:flex rounded-md"
                icon={AddNewTalentColoredIcon}
                title={"Create Folder"}
              />
              <Button
                onClick={() => this.toggleShareProjectModal(projectId)}
                className="hidden md:flex rounded-md"
                icon={ShareIcon}
                title={"Share Project"}
              />
              <Button
                onClick={() => this.toggleShareProjectModal(projectId)}
                className="flex md:hidden rounded-md"
                icon={ShareIcon}
              />

              <Button
                onClick={() => this.toggleDeleteModal()}
                className=" md:flex rounded-md group"
                ricon={
                  <LuTrash className="text-[#F89A1F] group-hover:text-white text-xl"></LuTrash>
                }
              />
            </div>
          </div>
          <div className="flex justify-end mx-6 py-3 gap-3 lg:gap-6"></div>
          <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
            <div className="flex flex-col lg:flex-row flex-wrap gap-2">
              {voiceStore.searchNavVisible && <SearchNav></SearchNav>}

              <div className={`flex flex-1 flex-col bg-white rounded-md pb-5`}>
                <div className="flex flex-row border-b">
                  <div className="flex flex-1 px-2 rounded-md items-center mx-2 font-semibold">
                    VO Library
                  </div>
                  <Button
                    onClick={() => {
                      voiceStore.setSearchNavVisible(
                        !voiceStore.searchNavVisible
                      );
                    }}
                    className="h-10 mt-2 mr-5 mb-2"
                    icon={SearchColoredIcon}
                  />
                </div>

                <div className="flex flex-1 relative pt-4">
                  {voiceStore.searchResults.length > 0 ? (
                    this.renderTree(
                      this.convertToFolderTree(voiceStore.searchResults)
                    )
                  ) : (
                    <div className="flex flex-1 flex-col justify-center items-center gap-2">
                      <LuFilePlus className="text-4xl text-[#F89A1F]" />
                      <span>Search voice overs</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="hidden lg:flex h-screen w-[1px] bg-gray-400"></div>

              <div
                className={`flex flex-1 flex-col bg-white rounded-md pb-20 lg:p-0`}
              >
                <div className="flex flex-row border-b">
                  <div className="flex flex-1 px-2 lg:h-14 rounded-md items-center mx-2 font-semibold">
                    Project View
                  </div>
                  <Button
                    onClick={this.handleCreateFolder}
                    className="lg:hidden h-10 mt-2 mr-5 mb-2"
                    icon={AddNewTalentColoredIcon}
                  />
                </div>
                {this.state.rightPanelFolders.length === 0 && (
                  <div className="flex flex-1 flex-col justify-center items-center gap-2">
                    <img
                      className="w-11 lg:w-12 "
                      src={CloudIconColored}
                      alt="Cloud"
                    />
                    <span className="font-medium text-sm text-[#130D0D]">
                      Create a folder then Drag & drop the voice here
                    </span>
                  </div>
                )}
                <div className="mt-2">{this.renderRightPanelFolders()}</div>
              </div>
              <Button
                disabled={loading}
                onClick={() => {
                  console.log("Saving project..."); // Debug log
                  const folderNames = this.state.rightPanelFolders.map((folder) => folder.name);
                  const duplicateNames = folderNames.filter(
                    (name, index) => folderNames.indexOf(name) !== index
                  );
              
                  console.log("Folder names:", folderNames); // Debug log
                  console.log("Duplicate folder names:", duplicateNames); // Debug log
              
                  const folderIds = this.state.rightPanelFolders.map((folder) => folder.id);
                  const duplicateIds = folderIds.filter(
                    (id, index) => folderIds.indexOf(id) !== index
                  );
              
                  console.log("Folder IDs:", folderIds); // Debug log
                  console.log("Duplicate folder IDs:", duplicateIds); // Debug log
              
                  const folderChildren = this.state.rightPanelFolders.flatMap((folder) =>
                    folder.children.map((child) => child.sample_id)
                  );
                  const duplicateChildren = folderChildren.filter(
                    (id, index) => folderChildren.indexOf(id) !== index
                  );
              
                  console.log("Child sample IDs:", folderChildren); // Debug log
                  console.log("Duplicate child sample IDs:", duplicateChildren); // Debug log
              
                  this.setState({ loading: true });
              
                  if (duplicateNames.length > 0 || duplicateIds.length > 0 || duplicateChildren.length > 0) {
                    toast.error(
                      "There are duplicate folder names, IDs, or child sample IDs. Please resolve them."
                    );
                    this.setState({ loading: false });
                  } else {
                    projectStore
                      .saveProject({
                        projectId,
                        folders: this.state.rightPanelFolders,
                      })
                      .then((data) => {
                        console.log("Save successful. Response data:", data); // Debug log
                        this.setState({ loading: false });
                        this.loadData(data);
                      })
                      .catch((error) => {
                        console.error("Save failed. Error:", error); // Debug log
                        this.setState({ loading: false });
                      });
                  }
                }}
                className={`fixed bottom-3 right-5 ${
                  voiceStore.currentVoice && "!bottom-[4.5rem]"
                }  lg:flex lg:fixed lg:right-14 lg:bottom-10`}
                title={
                  loading ? (
                    <Bars
                      height="20"
                      width="25"
                      color="#F89A1F"
                      ariaLabel="bars-loading"
                      visible={loading}
                    />
                  ) : (
                    "Save"
                  )
                }
              />
            </div>
          </DndProvider>

          {/* Delete Modal */}
          {this.state.showDeleteModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[100]">
              <div className="bg-white rounded-lg p-5 w-[22rem]">
                <div className="flex flex-row justify-start items-center gap-x-2 mb-4">
                  <PiWarningCircleFill color="#F89A1F" />
                  <span className="font-normal text-sm">
                    Are you sure you want to delete this project?
                  </span>
                </div>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={this.toggleDeleteModal}
                    className="border border-[#D9D9D9] bg-white rounded-sm"
                  >
                    <span className="font-normal text-sm px-3">No</span>
                  </button>
                  <button
                    onClick={() =>
                      this.handleDelete({
                        clientName,
                        projectId,
                        projectYear: year,
                      })
                    }
                    className="border border-black bg-black rounded-sm"
                  >
                    <span className="font-normal text-sm px-3 text-white">
                      Yes
                    </span>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Share Project Modal */}
          {this.state.showShareProjectModal && (
            <div className="z-50 fixed  inset-0 bg-black bg-opacity-50 flex justify-center items-center">
              <div className="bg-white relative rounded-lg p-5 w-[90%] lg:w-2/5">
                <div className="flex flex-col gap-y-4">
                  <span className="font-bold text-3xl text-[#21272A]">
                    Share Via
                  </span>
                  <span className="font-normal text-base text-[#21272A]">
                    Share Project !
                  </span>
                </div>

                <div className="flex flex-row gap-x-12 justify-center mt-6">
                  <a
                    href="mailto:"
                    className="flex flex-col justify-center items-center gap-y-2"
                  >
                    <span className="p-4 bg-[#2222220F] rounded-full text-xl">
                      <LuMail></LuMail>
                    </span>
                    <span className="font-normal text-xs text-[#888888]">
                      Email
                    </span>
                  </a>

                  <button
                    onClick={() => {
                      this.copyToClipboard(this.state.shareProjectLink);
                      setTimeout(() => {
                        window.open("https://web.whatsapp.com", "_blank");
                      }, 500);
                    }}
                    className="flex flex-col justify-center items-center gap-y-2"
                  >
                    <span className="p-4 bg-[#2222220F] rounded-full text-xl">
                      <FaWhatsapp></FaWhatsapp>
                    </span>
                    <span className="font-normal text-xs text-[#888888]">
                      Whatsapp
                    </span>
                  </button>
                </div>

                <div className="flex flex-row justify-between items-center border p-3 mt-6">
                  <span className="font-normal text-sm text-[#8D9CA5] w-full overflow-hidden text-ellipsis whitespace-nowrap">
                    {this.state.shareProjectLink
                      ? this.state.shareProjectLink
                      : "The link could not be created"}
                  </span>
                  <button
                    disabled={this.state.shareProjectLink ? false : true}
                    onClick={() => {
                      this.copyToClipboard(this.state.shareProjectLink);
                    }}
                    className="text-base ml-3"
                  >
                    <LuCopy></LuCopy>
                  </button>
                  <button
                    disabled={this.state.shareProjectLink ? false : true}
                    onClick={() => {
                      window.open(this.state.shareProjectLink, "_blank");
                    }}
                    className="text-base ml-3"
                  >
                    <LuExternalLink></LuExternalLink>
                  </button>
                </div>

                <div className="flex flex-row justify-end gap-4 mt-6">
                  <Button
                    onClick={() => {
                      this.copyToClipboard(this.state.shareProjectLink);
                      this.toggleShareProjectModal();
                    }}
                    title="Share"
                  ></Button>
                </div>

                <button
                  onClick={() => {
                    this.toggleShareProjectModal();
                  }}
                  className="absolute right-7 top-5 text-xl"
                >
                  <FaTimes></FaTimes>
                </button>
              </div>
            </div>
          )}
        </div>
      );
    }
  }
);

export default withRouter(ProjectDetail);
